import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	CollapseComponent,
	InfoGroupComponent,
	LinkComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { IFinishOperation, OPERATION_TYPE } from '../../../../../operations/models/operations.models';
import { DeveloperCurlButtonComponent } from '../../../../../shared/components/developer-curl-button/developer-curl-button.component';

@Component({
	selector: 'app-finish-operation',
	imports: [
		TranslatePipe,
		CollapseComponent,
		InfoGroupComponent,
		LinkComponent,
		TileComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './finish-operation.component.html',
	styleUrl: './finish-operation.component.scss',
})
export class FinishOperationComponent implements OnInit {
	@Input() operation?: IFinishOperation;
	@Input() index: number = 1;
	@Input() profileUuid?: string;

	ngOnInit(): void {
		if (this.operation && this.operation.type !== OPERATION_TYPE.FINISH) {
			this.operation = undefined;
		}
	}

	public operationCurlPath(): string {
		if (!this.profileUuid || !this.operation?.uuid) return '';
		return `/profile/${this.profileUuid}/operations/${this.operation.uuid}`;
	}
}
